import React from "react";
import { Navigate } from "react-router-dom";
import { DistributorDashboard, PreSalesDashboard } from "./lazyPages";

// Same source the sidebar uses — a user with no dealer (empty or 0) is the distributor
const isDistributorUser = () => {
  const user = JSON.parse(localStorage.getItem("permissions") || "{}");
  return !(Number(user?.dealerId) > 0);
};

// "/" — each login's own home dashboard, without a dashboard URL
export const HomeDashboard = () =>
  isDistributorUser() ? <DistributorDashboard /> : <PreSalesDashboard />;

// Dealer dashboards are not for the distributor, and the other way round → back to home
export const DealerOnly = ({ children }) =>
  isDistributorUser() ? <Navigate to="/" replace /> : children;

export const DistributorOnly = ({ children }) =>
  isDistributorUser() ? children : <Navigate to="/" replace />;
